<template>
  <div class="chat-container rounded-xl border border-gray-200 bg-white pl-3">
    <div class="chat-list py-3">
      <div class="chat-list-header">
        <h3 class="card-title d-flex">AI Chats</h3>
        <vs-button type="filled" class="searchBtn" icon="cached" @click="handleRefreshChat()" style="border-radius: 100%"></vs-button>
      </div>
      <div class="chat-list-items">
        <div
          v-for="chat in latestChats"
          :key="chat._id"
          :class="['chat-list-item', { selected: selectedChat && selectedChat._id === chat._id }]"
          @click="selectChat(chat)"
        >
          <div class="chat-list-item-title">
            <span>{{ chat.userId ? "UserID: " + chat.userId : "DeviceID: " + chat.deviceId || "Unknown" }}</span>
          </div>
          <div class="chat-list-item-message">{{ chat.role === "assistant" ? "BOT: " : "USER: " }}{{ chat.message.substring(0, 43) }}...</div>
          <div class="chat-list-item-date">
            {{ formatDate(chat.createdAt) }}
          </div>
        </div>
        <div ref="chatListScrollAnchor"></div>
        <div v-if="!latestChats.length" class="no-chats">No chats found.</div>
      </div>
    </div>

    <!-- message box -->
    <div class="flex-1">
      <div v-if="selectedChat">
        <ChatMessageBox :chat="selectedChat" />
      </div>
      <div v-else class="no-chat-selected">
        <p>Select a chat to view messages</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import ChatMessageBox from "./ChatMessageBox.vue";
import moment from "moment";

export default {
  name: "Chats",
  components: { ChatMessageBox },
  data: () => ({
    latestChats: [],
    limit: 10,
    page: 1,
    selectedChat: null,
    loadingMore: false,
    isMore: true,
    scrollListener: null,
  }),
  methods: {
    async handleRefreshChat() {
      this.selectedChat = null;
      this.page = 1;
      await this.fetchLatestMessages();
    },

    async loadMore() {
      if (this.loadingMore || !this.isMore) return;
      this.loadingMore = true;
      this.page += 1;
      await this.fetchLatestMessages(true);
      this.loadingMore = false;
    },
    handleScroll(e) {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        this.loadMore();
      }
    },

    async fetchLatestMessages(append = false) {
      this.$vs.loading();
      try {
        const res = await api.get(`${API.AI_GET_LATEST_MESSAGES}?limit=${this.limit}&page=${this.page}`);
        if (res.status === 200) {
          if (res.data.hasMore === false) this.isMore = false;
          if (append) {
            this.latestChats = [...this.latestChats, ...res.data.data];
          } else this.latestChats = res.data.data;
          // autoload gpt
          this.$nextTick(() => {
            const chatList = this.$el.querySelector(".chat-list-items");
            if (chatList && chatList.scrollHeight <= chatList.clientHeight && this.isMore && !this.loadingMore && this.latestChats.length > 0) {
              this.loadMore();
            }
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error fetching latest messages",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    selectChat(chat) {
      this.selectedChat = chat;
    },
    formatDate(dateStr) {
      const m = moment(dateStr);
      if (!m.isValid()) return "Invalid date";
      return m.format("MMM DD, YYYY hh:mm A");
    },
  },
  async created() {
    await this.fetchLatestMessages();
  },
  mounted() {
    const chatList = this.$el.querySelector(".chat-list-items");
    if (chatList) {
      chatList.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const chatList = this.$el.querySelector(".chat-list-items");
    if (chatList) {
      chatList.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style scoped>
.chat-container {
  @apply flex h-full overflow-hidden;
}

.chat-list {
  min-width: 320px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-list-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 0.5rem;
  padding-right: 0.5rem;
}

.chat-list-items {
  flex: 1;
  overflow-y: auto;
}

.chat-list-item {
  padding: 8px 10px 5px 0px;
  border-bottom: 1px solid #ececec;
  cursor: pointer;
  transition: background 0.2s;
}

.chat-list-item.selected {
  background: #1f4388;
  color: white;
}

.chat-list-item-title {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 2px;
}

.chat-list-item-message {
  font-size: 13px;
  margin-bottom: 2px;
}

.chat-list-item-date {
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
}

.no-chats {
  padding: 24px;
  text-align: center;
}
.load-more-container {
  display: flex;
  justify-content: center;
}
.no-chat-selected {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #aaa;
  font-size: 18px;
}
</style>
